const STORAGE_KEY = "bcm-product-notice-dismissed";

type DismissedStore = Record<string, string[]>;

function readStore(storage: Storage): DismissedStore {
  try {
    const parsed = JSON.parse(storage.getItem(STORAGE_KEY) ?? "{}") as unknown;
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed))
      return {};
    return parsed as DismissedStore;
  } catch {
    return {};
  }
}

export function readDismissedNoticeIds(
  userId: string,
  storage: Storage,
): Set<string> {
  const ids = readStore(storage)[userId];
  return new Set(
    Array.isArray(ids) ? ids.filter((id) => typeof id === "string") : [],
  );
}

export function dismissProductNotice(
  userId: string,
  noticeId: string,
  storage: Storage,
): Set<string> {
  const store = readStore(storage);
  const ids = new Set(readDismissedNoticeIds(userId, storage));
  ids.add(noticeId);
  store[userId] = [...ids];
  storage.setItem(STORAGE_KEY, JSON.stringify(store));
  return ids;
}
